const cache = {};
const pending = {};
const listeners = new Set();

const notify = (api) => {
  if (!api) {
    listeners.forEach((listener) => {
      try {
        listener(null);
      } catch (err) {
        console.error('lookupCache listener error', err);
      }
    });
    return;
  }

  listeners.forEach((listener) => {
    try {
      listener(api);
    } catch (err) {
      console.error('lookupCache listener error', err);
    }
  });
};

export const getCache = (api) => cache[api];
export const setCache = (api, data) => { cache[api] = data; };
export const clearCache = (api) => {
  if (api) {
    delete cache[api];
    notify(api);
  } else {
    Object.keys(cache).forEach((key) => delete cache[key]);
    notify(null);
  }
};

export const subscribeToLookupCache = (listener) => {
  if (typeof listener !== 'function') {
    return () => {};
  }

  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const getOrFetch = (api, loader) => {
  if (cache[api]) {
    return Promise.resolve(cache[api]);
  }
  if (!pending[api]) {
    pending[api] = Promise.resolve()
      .then(() => loader())
      .then((data) => {
        cache[api] = data;
        delete pending[api];
        return data;
      })
      .catch((err) => {
        delete pending[api];
        throw err;
      });
  }
  return pending[api];
};
